
import { ShowItemQuantityService } from 'application/services/show-item-quantity'
import { api } from 'infra/adapters/http-client-adapter'

export const handleQuantityItem = new ShowItemQuantityService(api)
